import { render } from "./Cacheclear.vue?vue&type=template&id=45971db8"
import script from "./Cacheclear.vue?vue&type=script&lang=js"
export * from "./Cacheclear.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__